import React, { useEffect, useRef, useState } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Fade, Modal, Typography } from '@mui/material';
import ModalForCard from '../../molecules/modal-for-card/modalForCard';
import { separarPorHR } from '../../../utils/arrayUtils';
import Button2 from '../../atoms/button2/button2';
import * as styles from './cards2.module.scss';

export interface ICards2Props {
    title: string;
    subtitle: any;
    bg: string;
    cardsList: {
        bg: string;
        title: string;
        icon: string;
        text: string;
        textColor: string;
        modalInfo: any;
        btnLabel: string;
        btnRedirect: string;
    }[];
}

const Cards2 = ({ title, subtitle, bg, cardsList }: ICards2Props) => {
    const [isVisible, setIsVisible] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [selectedCard, setSelectedCard] = useState<any>();
    const cards2Ref = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsVisible(entries[0].isIntersecting);
            }
        });
        if (cards2Ref.current) {
            observer.observe(cards2Ref.current);
        }
        return () => observer.disconnect();
    }, []);

    const handleOpenModal = (card) => {
        setSelectedCard(card);
        setOpenModal(true);
    };

    return (
        <Fade in={isVisible} timeout={1000}>
            <section ref={cards2Ref} className={styles.o_cards2}>
                <img className={styles.o_cards2__bg} src={bg} alt="" />
                <>
                    {subtitle && (
                        <Typography variant="body1" className="a-home__desc">
                            {subtitle}
                        </Typography>
                    )}
                    {title && (
                        <Typography component="h2" className="a-home__h2">
                            {title}
                        </Typography>
                    )}
                </>
                <div className={styles.o_cards2__cards}>
                    {cardsList.map((card, index) => (
                        <>
                            <div
                                key={index}
                                className={styles.o_cards2__card}
                                style={{
                                    backgroundImage: `url(${card.bg})`,
                                    color: card.textColor,
                                }}
                            >
                                <h3>{card.title}</h3>
                                <i className={card.icon} />
                                <p>{card.text}</p>
                                {card.btnRedirect ? (
                                    <a href={card.btnRedirect}>
                                        {card.btnLabel || 'ver más'}
                                    </a>
                                ) : card.btnLabel ? (
                                    <button
                                        onClick={() => handleOpenModal(card)}
                                    >
                                        {card.btnLabel}
                                    </button>
                                ) : null}
                            </div>
                        </>
                    ))}
                </div>
                {selectedCard && selectedCard.modalInfo && (
                    <Modal
                        open={openModal}
                        onClose={() => setOpenModal(false)}
                        className={styles.o_cards2__modal}
                    >
                        <>
                            {selectedCard && selectedCard.modalInfo && (
                                <ModalForCard
                                    data={separarPorHR(
                                        documentToReactComponents(
                                            JSON.parse(
                                                selectedCard.modalInfo.raw,
                                            ),
                                        ),
                                    )}
                                >
                                    <Button2
                                        label="Cerrar"
                                        classname="m_modalforcard__modalbtn"
                                        onClick={() => setOpenModal(false)}
                                    />
                                </ModalForCard>
                            )}
                        </>
                    </Modal>
                )}
            </section>
        </Fade>
    );
};

export default Cards2;
